import React from 'react'

interface Props {
  dimensions: string
  state: string
  stateName: string
  fill: string
  onClickState: (event: React.BaseSyntheticEvent) => void
  showLabel?: boolean
  labelOffsets?: Record<string, { x: number; y: number; isExternal?: boolean }>
}

import svgPathBoundingBox from 'svg-path-bounding-box'

export const USAState = ({
  dimensions,
  state,
  stateName,
  fill,
  onClickState,
  showLabel,
  labelOffsets,
}: Props) => {
  let cx = 0
  let cy = 0

  let isExternal = false

  if (showLabel) {
    const box = svgPathBoundingBox(dimensions)
    cx = (box.minX + box.maxX) / 2
    cy = (box.minY + box.maxY) / 2

    // Apply any manual offset overrides
    if (labelOffsets && labelOffsets[state]) {
      if (labelOffsets[state].isExternal) {
        isExternal = true
      } else {
        cx += labelOffsets[state].x
        cy += labelOffsets[state].y
      }
    }
  }

  return (
    <g className={`${state} state group cursor-pointer`} onClick={onClickState} data-name={state}>
      <path
        d={dimensions}
        fill={fill}
        className="transition-colors duration-200 stroke-white stroke-[0.5px]"
        data-name={state}
      >
        <title>{stateName}</title>
      </path>
      {showLabel && !isExternal && (
        <text
          x={cx}
          y={cy}
          textAnchor="middle"
          alignmentBaseline="central"
          className="pointer-events-none fill-black font-medium text-[10px] select-none"
          data-name={state}
        >
          {state}
        </text>
      )}
      {showLabel && isExternal && labelOffsets && labelOffsets[state] && (
        <>
          <line
            x1={cx}
            y1={cy}
            x2={labelOffsets[state].x - 6}
            y2={labelOffsets[state].y}
            stroke="#1a1a1a"
            strokeWidth="0.5"
            className="pointer-events-none"
          />
          <text
            x={labelOffsets[state].x}
            y={labelOffsets[state].y}
            textAnchor="start"
            alignmentBaseline="central"
            className="pointer-events-none fill-black font-medium text-[10px] select-none"
            data-name={state}
          >
            {state}
          </text>
        </>
      )}
    </g>
  )
}
